import axios from "axios";
import { getToken } from "./storage";
import { getEnvironment } from "./environment";
import { handleApiError, handleApiSuccess, handleApiStart } from "./contextualLoaderTrigger";
import { consumeUserGesture } from "./userGesture";

const { API_URL, PHP_API_BASE_URL } = getEnvironment();

export const CancelToken = axios.CancelToken;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// API Request Interceptor
api.interceptors.request.use(
  (config) => {
    const { url } = config;
    const userGesture = consumeUserGesture();
    handleApiStart(url, userGesture);
    const token = getToken();

    // Block the api call if 'access-token' is unavailable
    if (!token) {
      const cancelToken = new CancelToken((cancel) => cancel("Rejected"));
      return { ...config, cancelToken };
    }

    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Add Response Interceptor
api.interceptors.response.use(
  (response) => {
    const { url } = response?.config;
    !response ? handleApiError(url) : handleApiSuccess(url);
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    // Any status codes outside
    handleApiError(error.config.url, error)
    if (error.response && (status === 403 || error.response.statusText === "Unauthorized")) {
      window.location.href = "/logout";
    } else if (status === 428) {
      window.location.href = "/stepper";
    }
    return Promise.reject(error);
  }
);

export async function apiData(req, contentType = "application/json", stack = "node") {
  const { url, method, data } = req;
  const userGesture = consumeUserGesture();
  handleApiStart(url, userGesture);
  const apiBaseUrl = stack === "php" ? PHP_API_BASE_URL : API_URL;
  try {
    const res = await axios({
      url: apiBaseUrl + url,
      method: method,
      data: data,
      headers: {
        "Content-Type": contentType,
        Authorization: `Bearer ${getToken()}`,
      },
    });
    !res ? handleApiError(url) : handleApiSuccess(url);
    return res.data;
  } catch (error) {
    const status = error?.response?.status;
    error?.response?.status !== 400 ? handleApiError(url, error) : handleApiSuccess(url);
    // Handle 403 error (Unauthorized)
    if (error.response && (status === 403 || error.response.statusText === "Unauthorized")) {
      window.location.href = "/logout";
    } else if (status === 428) {
      window.location.href = "/stepper";
    }
    console.log("Failed to fetch data", error);
    return error.response.data;
  }
}

export default api;
